<template>
  <div class="down" v-if="theme !== 'nonghe'">
    <div class="btn" @click="goToDown">{{ text }}</div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'component_name',
  props: {
    text: {
      type: String,
      default: '下载呼呼打药APP，体验更多功能',
    },
  },
  data() {
    return {
      isShowFlag: true,
    };
  },
  computed: { ...mapState(['theme']) },
  mounted() {},
  methods: {
    goToDown() {
      this.$router.push({ path: '/down' });
    },
  },
  watch: {},
  destroyed() {},
  components: {},
};
</script>
<style lang="stylus" scoped>
.down
  position absolute
  bottom 30px
  left 0
  right 0
  .btn
    display block
    width 90%
    margin 0 auto
    height 40px
    background #FF9922
    font-size 14px
    font-family Microsoft YaHei
    font-weight 400
    color rgba(255, 255, 255, 1)
    line-height 40px
    border-radius 5px
</style>
